import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { isEqual, isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import {
	UserEmailModelState,
	UserEmailModelStore,
} from 'user/email-model/user-email-model.store';
import { UserEmailModelRepositoryPort } from 'user/port/email/user-email-model-repository.port';
import { UserEmailModel } from 'user/user-email-model';

import { CacheObservable } from '../../../app-decorators';

@Injectable()
export class UserEmailModelRepositoryAdapter
	extends QueryEntity<UserEmailModelState>
	implements UserEmailModelRepositoryPort
{
	constructor(protected store: UserEmailModelStore) {
		super(store);
	}

	@CacheObservable()
	public observeUserEmailModels(userId: string): Observable<UserEmailModel[]> {
		return this.selectAll({
			filterBy: (entity) => isEqual(entity.userId, userId),
		}).pipe(
			distinctUntilChanged(isEqual),
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveUserEmailModels(entities: UserEmailModel[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
